import React from "react";
import type { BaseProps } from "@purpur/common-types";
import c from "classnames/bind";

import styles from "./skeleton.module.scss";

export const radii = ["xs", "sm", "md", "lg", "full"] as const;
export type SkeletonRadius = (typeof radii)[number];

export type SkeletonProps = Omit<BaseProps, "children"> & {
  radius?: SkeletonRadius;
  negative?: boolean;
};

const cx = c.bind(styles);
const rootClassName = "purpur-skeleton";

export const Skeleton = ({
  className,
  radius = "xs",
  negative = false,
  ...props
}: SkeletonProps) => {
  const classes = cx(
    className,
    rootClassName,
    `${rootClassName}--${negative ? "negative" : "default"}`,
    `${rootClassName}--${radius}`
  );

  return <div className={classes} {...props} />;
};

Skeleton.displayName = "Skeleton";
